var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpeakerphone = function SvgSpeakerphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.25 11A2.25 2.25 0 0 0 18 8.75a.75.75 0 0 1 0-1.5 3.75 3.75 0 0 1 0 7.5.75.75 0 0 1 0-1.5A2.25 2.25 0 0 0 20.25 11M6.25 19v-5a.75.75 0 0 1 1.5 0v5a.25.25 0 0 0 .25.25h1a.25.25 0 0 0 .25-.25V8a.75.75 0 0 1 1.5 0v11A1.75 1.75 0 0 1 9 20.75H8A1.75 1.75 0 0 1 6.25 19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.25 4.922a.15.15 0 0 0-.246-.115l-4.524 3.77a.75.75 0 0 1-.48.173H4a.25.25 0 0 0-.25.25v4a.25.25 0 0 0 .25.25h8l.13.012a.75.75 0 0 1 .35.162l4.524 3.77q.034.028.077.034a.152.152 0 0 0 .169-.15zm1.5 12.155a1.651 1.651 0 0 1-2.706 1.27v-.001l-4.315-3.596H4A1.75 1.75 0 0 1 2.25 13V9A1.75 1.75 0 0 1 4 7.25h7.729l4.315-3.597.093-.07a1.651 1.651 0 0 1 2.613 1.339z"
  })));
};
export default SvgSpeakerphone;